import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { report } from 'state/modules/error';
import ErrorMessage from 'components/Common/Messages/ErrorMessage';

export class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    intl: PropTypes.object.isRequired,
    report: PropTypes.func.isRequired,
  };

  static defaultProps = {
    children: null,
  };

  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { report } = this.props;
    const { message, stack } = error;
    const { componentStack } = errorInfo;
    report(message, stack, componentStack);
  }

  render() {
    const { hasError } = this.state;
    const { children, intl: { formatMessage } } = this.props;

    // Check if there's an error to render
    if (hasError) {
      return (
        <ErrorMessage title={formatMessage({ id: 'general.error.title' })} onRetry={() => window.location.reload()}>
          <FormattedTranslation id="general.error.message" />
        </ErrorMessage>
      );
    }

    // Normally, just render children
    return children;
  }
}

export default connect(() => ({}), { report })(injectIntl(ErrorBoundary));
